var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutPublic',[_c('NavBarPublic'),_c('HeroSection',{attrs:{"data-hero":_vm.dataHero}}),_c('CalloutSection'),_c('DesignSection'),_c('LayananSection'),_c('BeritaSection',{attrs:{"page":"home"}}),_c('FooterPublic')],1)}
var staticRenderFns = []

export { render, staticRenderFns }